// Sparkline de una sola serie en SVG: área tenue, línea y punto final; cada punto con su tooltip.
import { cn } from '@/lib/cn';

const WIDTH = 160;
const HEIGHT = 36;
const PAD = 3;

/** La escala va de 0 al máximo de la serie; `pointTitles` da el tooltip de cada punto. */
export function Sparkline({
    values,
    label,
    pointTitles,
    className,
}: {
    values: readonly number[];
    label: string;
    pointTitles?: readonly string[];
    className?: string;
}) {
    if (values.length === 0) return null;
    const max = Math.max(...values, 1);
    const step = values.length > 1 ? (WIDTH - 2 * PAD) / (values.length - 1) : 0;
    const points = values.map((value, index) => ({
        x: PAD + index * step,
        y: HEIGHT - PAD - (value / max) * (HEIGHT - 2 * PAD),
    }));
    const line = points.map((p) => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' ');
    const first = points[0];
    const last = points[points.length - 1];
    const base = String(HEIGHT - PAD);
    return (
        <svg
            viewBox={`0 0 ${String(WIDTH)} ${String(HEIGHT)}`}
            className={cn('h-9 w-40 flex-none overflow-visible', className)}
            role="img"
            aria-label={label}
        >
            <polygon
                points={`${first.x.toFixed(1)},${base} ${line} ${last.x.toFixed(1)},${base}`}
                className="fill-muted"
            />
            <polyline
                points={line}
                fill="none"
                className="stroke-foreground"
                strokeWidth={1.5}
                vectorEffect="non-scaling-stroke"
            />
            <circle cx={last.x} cy={last.y} r={2.5} className="fill-foreground" />
            {pointTitles
                ? points.map((p, index) => (
                      <circle
                          key={index}
                          cx={p.x}
                          cy={p.y}
                          r={8}
                          className="fill-transparent"
                          data-testid="sparkline-point"
                      >
                          <title>{pointTitles[index]}</title>
                      </circle>
                  ))
                : null}
        </svg>
    );
}
